export default function FinancialFeasibility() {
  const budgetAssumptions = [
    {
      icon: 'ri-building-line',
      label: 'المساحة',
      value: '1,300 م²'
    },
    {
      icon: 'ri-group-line',
      label: 'عدد المستفيدين المتوقع',
      value: '7,200 – 10,800 سنويًا'
    },
    {
      icon: 'ri-calendar-line',
      label: 'التشغيل',
      value: 'سنة واحدة (200 يوم)'
    },
    {
      icon: 'ri-hand-coin-line',
      label: 'النموذج',
      value: 'دعم تأسيسي + تشغيل سنوي من شركات راعية'
    }
  ];

  const setupCosts = [
    {
      category: 'تهيئة الموقع والتصميم الداخلي',
      items: [
        { name: 'تصميم معماري وهوية مكانية', details: 'تجربة المستخدم', amount: 120000, quantity: 1, total: 120000 },
        { name: 'أعمال التشطيب', details: 'أرضيات – جدران – عزل – إضاءة', amount: 280000, quantity: 1, total: 280000 },
        { name: 'تقسيم المساحات', details: 'مكاتب – قاعات – غرف تفكير', amount: 150000, quantity: 1, total: 150000 },
        { name: 'أنظمة كهرباء وشبكات', details: 'مخارج – تمديدات – بنية تقنية', amount: 90000, quantity: 1, total: 90000 }
      ],
      subtotal: 640000
    },
    {
      category: 'الأثاث والتجهيزات',
      items: [
        { name: 'مكاتب وكراسي', details: '(50 مستخدم)', amount: 1500, quantity: 50, total: 75000 },
        { name: 'قاعات', details: 'قاعات اجتماعات وتدريب', amount: 20000, quantity: 6, total: 120000 },
        { name: 'ترفيه', details: 'منطقة ترفيه واسترخاء', amount: 70000, quantity: 1, total: 70000 },
        { name: 'استقبال', details: 'استقبال وصالة دخول', amount: 60000, quantity: 1, total: 60000 },
        { name: 'استيديو', details: 'استوديو محتوى (بودكاست / تصوير)', amount: 50000, quantity: 1, total: 50000 },
        { name: 'خزائن', details: 'خزائن وتخزين', amount: 30000, quantity: 1, total: 30000 }
      ],
      subtotal: 405000
    },
    {
      category: 'التجهيزات التقنية',
      items: [
        { name: 'أجهزة حاسب', details: 'الموظفين + القاعات + الاستقبال', amount: 3000, quantity: 15, total: 45000 },
        { name: 'شاشات عرض', details: 'القاعات + مساحة الترفيه + الاستديو', amount: 3500, quantity: 10, total: 35000 },
        { name: 'شبكة إنترنت احترافية', details: 'راوترات + مقويات إشارة + مودمات', amount: 45000, quantity: 1, total: 45000 },
        { name: 'أنظمة دخول ذكية', details: '', amount: 35000, quantity: 1, total: 35000 },
        { name: 'أنظمة صوت وتصوير', details: '', amount: 60000, quantity: 1, total: 60000 },
        { name: 'رخص وبرمجيات إدارة', details: '', amount: 30000, quantity: 1, total: 30000 }
      ],
      subtotal: 250000
    }
  ];

  const operatingCosts = [
    {
      category: 'الموارد البشرية',
      items: [
        { name: 'مدير المساحة', details: '10,000 شهرياً', amount: 120000, quantity: 1, total: 120000 },
        { name: 'مشرف تشغيل', details: '8,000 شهرياً', amount: 96000, quantity: 1, total: 96000 },
        { name: 'مسؤول برامج وشراكات', details: '9,000 شهرياً', amount: 108000, quantity: 1, total: 108000 },
        { name: 'مسؤول مجتمع وفعاليات', details: '7,000 شهرياً', amount: 84000, quantity: 1, total: 84000 },
        { name: 'استقبال وخدمات', details: '5,000 شهرياً', amount: 60000, quantity: 2, total: 120000 }
      ],
      subtotal: 528000
    },
    {
      category: 'التشغيل والخدمات',
      items: [
        { name: 'إيجار الموقع', details: '', amount: 250000, quantity: 1, total: 250000 },
        { name: 'كهرباء ومياه', details: '', amount: 7000, quantity: 12, total: 84000 },
        { name: 'إنترنت واتصالات', details: '', amount: 3000, quantity: 12, total: 36000 },
        { name: 'صيانة ونظافة', details: '', amount: 5000, quantity: 12, total: 60000 },
        { name: 'أمن وسلامة', details: '', amount: 3000, quantity: 12, total: 36000 }
      ],
      subtotal: 466000
    },
    {
      category: 'التسويق والهوية',
      items: [
        { name: 'هوية بصرية واتصال', details: '', amount: 40000, quantity: 1, total: 40000 },
        { name: 'محتوى رقمي وإعلام', details: '', amount: 60000, quantity: 1, total: 60000 },
        { name: 'حملات تسويقية', details: '', amount: 70000, quantity: 1, total: 70000 },
        { name: 'علاقات وشراكات', details: '', amount: 30000, quantity: 1, total: 30000 }
      ],
      subtotal: 200000
    }
  ];

  const formatCurrency = (amount: number) => {
    return amount.toLocaleString('en-US') + ' ر.س';
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            الجدوى المالية
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            افتراضات الموازنة للوضوح أمام الشركات
          </p>
        </div>

        {/* Budget Assumptions */}
        <div className="mb-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {budgetAssumptions.map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B6B]/10 to-[#FF8E53]/10 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-[#FF6B6B] text-2xl`}></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2 text-sm">{item.label}</h4>
                <p className="text-[#FF6B6B] font-bold text-lg">{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Setup Costs */}
        <div className="mb-20">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
            <div className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] p-8">
              <h3 className="text-3xl font-bold text-white flex items-center gap-3">
                <i className="ri-tools-line"></i>
                التكاليف التأسيسية
              </h3>
              <p className="text-white/90 mt-2">التكلفة تقديرية بناء على مقارنات مرجعية</p>
            </div>

            <div className="p-8">
              {setupCosts.map((section, sectionIndex) => (
                <div key={sectionIndex} className="mb-12 last:mb-0">
                  <h4 className="font-bold text-2xl text-gray-900 mb-6 pb-3 border-b-2 border-[#FF6B6B]/20">
                    {section.category}
                  </h4>
                  
                  <div className="hidden md:block overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gray-50">
                          <th className="text-right p-4 font-bold text-gray-700 rounded-tr-xl">البند</th>
                          <th className="text-right p-4 font-bold text-gray-700">توضيحات</th>
                          <th className="text-center p-4 font-bold text-gray-700">المبلغ</th>
                          <th className="text-center p-4 font-bold text-gray-700">العدد</th>
                          <th className="text-center p-4 font-bold text-gray-700 rounded-tl-xl">الإجمالي</th>
                        </tr>
                      </thead>
                      <tbody>
                        {section.items.map((item, itemIndex) => (
                          <tr key={itemIndex} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                            <td className="p-4 text-gray-900 font-medium">{item.name}</td>
                            <td className="p-4 text-gray-600 text-sm">{item.details}</td>
                            <td className="p-4 text-center text-gray-700">{formatCurrency(item.amount)}</td>
                            <td className="p-4 text-center text-gray-700">{item.quantity}</td>
                            <td className="p-4 text-center font-bold text-[#FF6B6B]">{formatCurrency(item.total)}</td>
                          </tr>
                        ))}
                        <tr className="bg-[#FF6B6B]/5">
                          <td colSpan={4} className="p-4 text-right font-bold text-gray-900">المجموع الفرعي</td>
                          <td className="p-4 text-center font-bold text-[#FF6B6B] text-lg">{formatCurrency(section.subtotal)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="md:hidden space-y-3">
                    {section.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                        <p className="font-bold text-gray-900 mb-1">{item.name}</p>
                        {item.details && <p className="text-gray-500 text-xs mb-3">{item.details}</p>}
                        <div className="flex justify-between items-center text-sm text-gray-600 mb-1">
                          <span>المبلغ × العدد</span>
                          <span>{formatCurrency(item.amount)} × {item.quantity}</span>
                        </div>
                        <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                          <span className="font-bold text-gray-700">الإجمالي</span>
                          <span className="font-bold text-[#FF6B6B]">{formatCurrency(item.total)}</span>
                        </div>
                      </div>
                    ))}
                    <div className="bg-[#FF6B6B]/10 rounded-xl p-4 flex justify-between items-center border border-[#FF6B6B]/20">
                      <span className="font-bold text-gray-900">المجموع الفرعي</span>
                      <span className="font-bold text-[#FF6B6B] text-lg">{formatCurrency(section.subtotal)}</span>
                    </div>
                  </div>
                </div>
              ))}

              <div className="mt-8 bg-gradient-to-r from-[#FF6B6B]/10 to-[#FF8E53]/10 p-4 md:p-6 rounded-2xl border-2 border-[#FF6B6B]/30">
                <div className="flex justify-between items-center gap-3">
                  <span className="font-bold text-base md:text-2xl text-gray-900">إجمالي التكاليف التأسيسية</span>
                  <span className="font-bold text-lg md:text-3xl text-[#FF6B6B] whitespace-nowrap">{formatCurrency(1295000)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Operating Costs */}
        <div className="mb-20">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
            <div className="bg-gradient-to-r from-[#FF8E53] to-[#FFA07A] p-8">
              <h3 className="text-3xl font-bold text-white flex items-center gap-3">
                <i className="ri-settings-3-line"></i>
                التكاليف التشغيلية السنوية
              </h3>
            </div>

            <div className="p-8">
              {operatingCosts.map((section, sectionIndex) => (
                <div key={sectionIndex} className="mb-12 last:mb-0">
                  <h4 className="font-bold text-2xl text-gray-900 mb-6 pb-3 border-b-2 border-[#FF8E53]/20">
                    {section.category}
                  </h4>
                  
                  <div className="hidden md:block overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gray-50">
                          <th className="text-right p-4 font-bold text-gray-700 rounded-tr-xl">البند</th>
                          <th className="text-right p-4 font-bold text-gray-700">توضيحات</th>
                          <th className="text-center p-4 font-bold text-gray-700">المبلغ</th>
                          <th className="text-center p-4 font-bold text-gray-700">العدد</th>
                          <th className="text-center p-4 font-bold text-gray-700 rounded-tl-xl">الإجمالي</th>
                        </tr>
                      </thead>
                      <tbody>
                        {section.items.map((item, itemIndex) => (
                          <tr key={itemIndex} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                            <td className="p-4 text-gray-900 font-medium">{item.name}</td>
                            <td className="p-4 text-gray-600 text-sm">{item.details}</td>
                            <td className="p-4 text-center text-gray-700">{formatCurrency(item.amount)}</td>
                            <td className="p-4 text-center text-gray-700">{item.quantity}</td>
                            <td className="p-4 text-center font-bold text-[#FF8E53]">{formatCurrency(item.total)}</td>
                          </tr>
                        ))}
                        <tr className="bg-[#FF8E53]/5">
                          <td colSpan={4} className="p-4 text-right font-bold text-gray-900">المجموع الفرعي</td>
                          <td className="p-4 text-center font-bold text-[#FF8E53] text-lg">{formatCurrency(section.subtotal)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="md:hidden space-y-3">
                    {section.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                        <p className="font-bold text-gray-900 mb-1">{item.name}</p>
                        {item.details && <p className="text-gray-500 text-xs mb-3">{item.details}</p>}
                        <div className="flex justify-between items-center text-sm text-gray-600 mb-1">
                          <span>المبلغ × العدد</span>
                          <span>{formatCurrency(item.amount)} × {item.quantity}</span>
                        </div>
                        <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                          <span className="font-bold text-gray-700">الإجمالي</span>
                          <span className="font-bold text-[#FF8E53]">{formatCurrency(item.total)}</span>
                        </div>
                      </div>
                    ))}
                    <div className="bg-[#FF8E53]/10 rounded-xl p-4 flex justify-between items-center border border-[#FF8E53]/20">
                      <span className="font-bold text-gray-900">المجموع الفرعي</span>
                      <span className="font-bold text-[#FF8E53] text-lg">{formatCurrency(section.subtotal)}</span>
                    </div>
                  </div>
                </div>
              ))}

              <div className="mt-8 bg-gradient-to-r from-[#FF8E53]/10 to-[#FFA07A]/10 p-4 md:p-6 rounded-2xl border-2 border-[#FF8E53]/30">
                <div className="flex justify-between items-center gap-3">
                  <span className="font-bold text-base md:text-2xl text-gray-900">إجمالي التكاليف التشغيلية السنوية</span>
                  <span className="font-bold text-lg md:text-3xl text-[#FF8E53] whitespace-nowrap">{formatCurrency(operatingCosts.reduce((sum, s) => sum + s.subtotal, 0))}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Total Budget Summary */}
        <div className="bg-gradient-to-br from-[#FF6B6B] via-[#FF8E53] to-[#FFA07A] rounded-3xl shadow-2xl overflow-hidden">
          <div className="p-6 md:p-12">
            <h3 className="text-2xl md:text-4xl font-bold text-white text-center mb-8 md:mb-12">
              إجمالي الموازنة الكلية (السنة الأولى)
            </h3>

            <div className="grid grid-cols-3 gap-3 md:gap-8 mb-6 md:mb-8">
              <div className="bg-white/10 backdrop-blur-sm p-3 md:p-8 rounded-2xl border border-white/20">
                <div className="text-center">
                  <i className="ri-tools-line text-2xl md:text-5xl text-white mb-2 md:mb-4"></i>
                  <p className="text-white/90 mb-1 text-xs md:text-lg leading-tight">التكاليف التأسيسية</p>
                  <p className="text-white font-bold text-xs md:text-3xl leading-tight">{formatCurrency(setupCosts.reduce((sum, s) => sum + s.subtotal, 0))}</p>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-3 md:p-8 rounded-2xl border border-white/20">
                <div className="text-center">
                  <i className="ri-settings-3-line text-2xl md:text-5xl text-white mb-2 md:mb-4"></i>
                  <p className="text-white/90 mb-1 text-xs md:text-lg leading-tight">التشغيل السنوي</p>
                  <p className="text-white font-bold text-xs md:text-3xl leading-tight">{formatCurrency(operatingCosts.reduce((sum, s) => sum + s.subtotal, 0))}</p>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-3 md:p-8 rounded-2xl border border-white/20">
                <div className="text-center">
                  <i className="ri-calculator-line text-2xl md:text-5xl text-white mb-2 md:mb-4"></i>
                  <p className="text-white/90 mb-1 text-xs md:text-lg leading-tight">الإجمالي</p>
                  <p className="text-white font-bold text-xs md:text-3xl leading-tight">{formatCurrency(setupCosts.reduce((sum, s) => sum + s.subtotal, 0) + operatingCosts.reduce((sum, s) => sum + s.subtotal, 0))}</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 md:p-8 rounded-2xl">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                <div className="flex items-center gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-16 md:h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-white text-lg md:text-3xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-600 text-xs md:text-sm mb-1">إجمالي الاستثمار المطلوب</p>
                    <p className="text-xl sm:text-4xl font-bold text-gray-900">
                      {formatCurrency(setupCosts.reduce((sum, s) => sum + s.subtotal, 0) + operatingCosts.reduce((sum, s) => sum + s.subtotal, 0))}
                    </p>
                  </div>
                </div>
                <div className="sm:text-right">
                  <p className="text-gray-600 text-sm mb-2">استثمار ذكي في:</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1.5 bg-[#FF6B6B]/10 text-[#FF6B6B] rounded-full text-sm font-bold">المستقبل</span>
                    <span className="px-3 py-1.5 bg-[#FF8E53]/10 text-[#FF8E53] rounded-full text-sm font-bold">المواهب</span>
                    <span className="px-3 py-1.5 bg-[#FFA07A]/10 text-[#FFA07A] rounded-full text-sm font-bold">الأثر</span>
                  </div>
                </div>
              </div>
              <div className="mt-5 flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
                <i className="ri-lightbulb-line text-amber-500 text-lg mt-0.5 flex-shrink-0"></i>
                <p className="text-amber-800 text-sm leading-relaxed">
                  <span className="font-bold">ملاحظة: </span>
                  يُتوقع أن تنخفض التكاليف التشغيلية إلى ما يقارب النصف بدءاً من النصف الثاني لانطلاقة المشروع، حين تبدأ عوائد التشغيل من الاشتراكات والبرامج والفعاليات في تغطية جزء جوهري من النفقات الجارية.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
